import React from 'react';
import { Input } from 'Components/Input';
import Select from 'Components/Select';

const BRAND_TYPES = [
  { name: 'Boat', value: 'BOAT' },
  { name: 'PWC', value: 'PWC' },
];

class BrandDetailsModal extends React.Component {
  render() {
    const { brandDetails, handleInputChange } = this.props;

    return (
      <section>
        <Input
          styleClass='primary'
          mainWrapperClassName='_width_pc_100 _text_align_left'
          label='Brand Name *'
          value={brandDetails.name}
          error={brandDetails.errors.name}
          onChange={handleInputChange('name')}
        />
        <Input
          styleClass='primary'
          mainWrapperClassName='_width_pc_100 _text_align_left'
          label='Website Address *'
          value={brandDetails.web}
          error={brandDetails.errors.web}
          onChange={handleInputChange('web')}
        />
        <Select
          selectionList={BRAND_TYPES}
          type='primary'
          mainWrapperClassName='_width_pc_100'
          itemNameIndicator={'name'}
          defaultItem={BRAND_TYPES.find(item => item.value === brandDetails.boatType)}
          label='Boat Type *'
          error={brandDetails.errors.boatType}
          withoutSearch
          handleSelect={handleInputChange('boatType')}
        />
      </section>
    );
  }
}

export default BrandDetailsModal;



// WEBPACK FOOTER //
// ./src/app/Scenes/SummaryScene/Brand.jsx